import { InformationCircleIcon } from '@heroicons/react/24/solid'
import { Tooltip } from 'flowbite-react'
import classNames from 'classnames'

interface InformationOnHoverProps {
  message: string
  className?: string
  placement?: 'top' | 'right' | 'bottom' | 'left' | 'auto'
}
const InformationOnHover = ({
  message,
  className,
  placement,
  ...rest
}: InformationOnHoverProps) => (
  <Tooltip
    content={message}
    trigger="click"
    placement={placement}
    {...rest}
  >
    {/** the button is added to make the tooltip closable when we click
     * everywhere in the app
     */}
    <button type="button">
      <InformationCircleIcon
        className={classNames(
          'h-5 w-5 text-blue-400 cursor-pointer',
          className,
        )}
      />
    </button>
  </Tooltip>
)

export default InformationOnHover
